module.exports = __webpack_public_path__ + "static/1-start-registration-4d9f27bf6d62281da7a27c4eb499c582.jpg";